import { patchState, signalStore, withMethods, withState } from "@ngrx/signals"

export type ScreenState = {
	screenWidth: number,
	screenHeight: number,
	screenSize: string
}

export const ScreenStore = signalStore(
	{ providedIn: "root"},
	withState<ScreenState>({
		screenWidth: 0,
		screenHeight: 0,
		screenSize: "web"
	}),
	withMethods((store) => ({
		setScreen(action: ScreenState): void {
			patchState(store, action)
		}
	}))
)
